import React, { memo } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';
import { FormSubmitButton } from '../../FormSubmitButton';
import { useBackNavigationLock } from 'hooks/useBackNavigationLock';

const SaveExitScreen = memo(function SaveExitScreen({
  onSubmit,
  handleSubmit,
  close,
  isSaveExit,
  form
}) {
  useBackNavigationLock();
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <PageHeading>{`Sure you want to exit?`}</PageHeading>
      <StandardBody>
        {isSaveExit ? (
          <>
            <p>{`If you exit your application, it won’t be taken any further right now – but we’ll save it for you so you can come back and complete it.`}</p>
            <p>{`Your application will be saved for 28 days from the day you’ve applied.`}</p>
          </>
        ) : (
          <p>{`If you exit now, your application won’t be saved and you’ll have to start again.`}</p>
        )}
      </StandardBody>
      <NavigationButtonGroup
        primaryButton={<FormSubmitButton formName={form} label="Yes, exit" />}
        secondaryButtons={
          <NavigationButton.Secondary
            labelText={`No, don’t exit`}
            onClick={(e) => {
              e.preventDefault();
              close();
            }}
          />
        }
      />
    </form>
  );
});

export { SaveExitScreen };
